<template>
  <modal :name="name" @before-open="beforeOpen" :width="400" :height="450" styles="overflow: visible">
    <div class="modal-run-trial">
      <div class="close" @click="close"></div>
      <div class="content">
        <div class="title">{{$t("run_configuration")}}</div>
        <template v-if="currentTrial">
          <div class="setting">
            <text-input-component class="disabled" label="duration" v-model="currentTrial.runConfig.duration" unit="Cardiac cycles" min="0.1" max="10"></text-input-component>
          </div>
          <div class="setting">
            <multi-select-component
              label="Modelling"
              mode="single"
              v-model="currentTrial.runConfig.modelling"
              :options="modellingOptions"
              class="selector disabled"
            ></multi-select-component>
          </div>
          <div class="setting setting-recap" v-if="currentTrial">
            <div class="trial-config-item trial-participants" v-if="currentTrial.cohortGeneration">
              <div class="trial-detail-icon participants-icon"></div>
              <div class="trial-detail-info">{{currentTrial.cohortGeneration.numberOfSubjects}} subjects</div>
            </div>
            <div class="trial-config-item trial-config-item-disease" v-if="infoDiseases">
              <div class="trial-info-icon"></div>
              {{infoDiseases}}
            </div>
            <div class="trial-config-item trial-config-item-tratmnet" v-if="infoTreatments">
              <div class="trial-info-icon"></div>
              {{infoTreatments}}
            </div>
            <div class="trial-config-item tokens-info">
              <div class="tokens-icon"></div>
              <span class="token-count">{{upToDate?currentTrial.runConfig.computeTokens+' '+$t('tokens'):'calculating...'}}</span>
            </div>
          </div>
          <div class="accept-btn btn btn--secondary" :class="{disabled: !upToDate}" @click="done">{{currentTrial.status == 'ready' ? $t('submit') : $t('save_config')}}</div>
        </template>
        <!-- <template v-else>
          Loading info...
        </template> -->
        
      </div>
    </div>
  </modal>
</template>

<script>

import MultiSelectComponent from '@/components/MultiSelectComponent'
import TextInputComponent from '@/components/TextInputComponent'
import { getValueTypeKey, getOption, setOption} from '@/utils/ConfigUtils'
import Api from '@/api'
import { debounce } from "debounce";
import trialConfig from '@/mixins/trialConfig'
export default {
  props: ['name','trial'],
  components: {MultiSelectComponent,TextInputComponent},
  data(){
    return {
      currentTrial: null,
      upToDate: true,
      modellingOptions: ['default','simple','complex'],
      mode: null,
      runningCallback: null
    }
  },
  mounted(){
    
  },
  asyncComputed:{
    
  },
  computed: {
     infoDiseases (){
      if(this.currentTrial && this.currentTrial.cohortGeneration && this.currentTrial.cohortGeneration.population && this.currentTrial.cohortGeneration.population.diseases){
        return this.currentTrial.cohortGeneration.population.diseases.map(d => d.name).join(', ')
      }
      return ''
    },
    infoTreatments () {
      if(this.currentTrial && this.currentTrial.treatments){
        return this.currentTrial.treatments.map(d => d.name).join(', ')
      }
      return ''
    }
  },
  methods:{
    beforeOpen(event) {
      // this.trial = event.params.trial
      this.currentTrial = JSON.parse(JSON.stringify( (event.params && event.params.trial) || this.trial ))
      this.runningCallback = event.params ? event.params.runningCallback : null
      this.mode = this.trial?'trial':'project'
      // this.duration = [+this.currentTrial.runConfig.duration]
      // this.modelling = this.currentTrial.runConfig.modelling
      // this.computeTokens = this.currentTrial.runConfig.computeTokens
      if(!this.unwatchers) this.unwatchers = []
      this.unwatchers.forEach((uw)=>uw())
      this.unwatchers = [
        this.$watch('currentTrial.runConfig.duration',this.debouncedUpdateCurrentTrial),
        this.$watch('currentTrial.runConfig.modelling',this.debouncedUpdateCurrentTrial)
      ]
    },
    done(){
      this.$emit('run',this.currentTrial)
      this.runningCallback && this.runningCallback()
      this.close()
    },
    close(){

      this.$modal.hide(this.name)
    },
    debouncedUpdateCurrentTrial: debounce(function(){this.updateCurrentTrial()},400),
    updateCurrentTrial(){
      this.upToDate = false
      Api.putTrial(this.currentTrial).then((res)=>{
        this.currentTrial=res
        this.upToDate = true
      })      
    }
  },
  watch:{

  }

}
</script>

<style scoped lang="stylus">
.modal-run-trial
  padding: 25px
  position relative
  height 100%
  .close
    cursor: pointer
    height: 15px
    m-icon("cross", 15)
    position: absolute
    right: 15px
    top: 15px
    // transform: translateY(-50%)
    width: @height
  .content
    height 100%
    display: flex;
    flex-direction: column;
    .title
      margin-bottom 20px
      m-font-size(17, 22)
      color $cloud-burst
      font-weight $fw-semi-bold
  .setting
    margin-bottom 15px
  .setting-recap
    border-top 1px solid $heather
    padding-top 15px
  .trial-config-item
    margin-bottom: 15px
    position: relative
    display flex
    align-items center
    color: rgba($cloud-burst, 0.6)
    m-font-size(13, 14)
    .trial-info-icon
      m-icon("patient-value-dark", 14)
      margin-right 5px
    .participants-icon
      margin-right 5px
      m-icon("participants", 14)
    &.tokens-info
      .tokens-icon
        m-icon("tokens", 14)
        margin-right 5px
    .btn
      width 120px
      margin-top auto
      margin-left: auto;
  .accept-btn
    margin-top auto

  .disabled
    opacity: 0.6
    pointer-events: none
</style>